import dayjs from 'dayjs';


const LINKS = {
  'December-2019': 'http://www.mrskin.com/playlist/show/918?_atc=900261-184-1-88386',
  'January-2020': 'http://www.mrskin.com/playlist/show/1006?_atc=900261-184-1-88401',
  'February-2020': 'http://www.mrskin.com/playlist/show/1243?_atc=900261-184-1-88389',
  'March-2020': 'http://www.mrskin.com/playlist/show/162?_atc=900261-184-1-88395',
  'April-2020': 'https://www.mrskin.com/playlist/show/1083?_atc=900261-184-1-88404',
  'DEFAULT': 'https://www.mrskin.com/tour?_atc=888591-2-1',
};

export default () => LINKS[dayjs().format('MMMM-YYYY')] || LINKS.DEFAULT;
